import { render, staticRenderFns } from "./SinglePage.vue?vue&type=template&id=2475e61e&scoped=true"
import script from "./SinglePage.vue?vue&type=script&lang=js"
export * from "./SinglePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2475e61e",
  null
  
)

export default component.exports